import { createContext, useContext } from "react";
import { noop } from "../../utils/noop.js";
const ExpandParentContext = createContext({
  expandParent: noop,
  parentIsExpanded: true
});
function useExpandParentContext() {
  return useContext(ExpandParentContext);
}
const DepthContext = createContext(0);
const FocusableContext = createContext({
  nextFocusable: () => null,
  previousFocusable: () => null
});
function useFocusableContext() {
  return useContext(FocusableContext);
}
export {
  DepthContext,
  ExpandParentContext,
  FocusableContext,
  useExpandParentContext,
  useFocusableContext
};
//# sourceMappingURL=Contexts.js.map
